"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "m21 1-8.59 8.59L21 18.18zM4.77 4.5 3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73z"
}), 'SignalCellularOff');